module.exports = __webpack_public_path__ + "static/media/IMG_5705.a8bd05bf.jpg";